// API Configuration
const defaultHost = typeof window !== 'undefined' && window.location && window.location.hostname
  ? window.location.hostname
  : 'localhost';
export const API_BASE_URL = process.env.REACT_APP_API_REQ_PATH ? process.env.REACT_APP_API_URL || `http://${defaultHost}:8080` : '';

// File Upload Configuration
export const UPLOAD_CONFIG = {
  MAX_FILE_SIZE: 5 * 1024 * 1024, // 5MB
  ALLOWED_IMAGE_TYPES: ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp'],
  ALLOWED_EXTENSIONS: ['.jpg', '.jpeg', '.png', '.gif', '.webp'],
  DEFAULT_AVATAR: '/images/default-avatar.svg'
};

// Error Messages
export const ERROR_MESSAGES = {
  INVALID_FILE_TYPE: 'Please select a valid image file (JPG, PNG, GIF, WebP)',
  FILE_TOO_LARGE: `File size cannot exceed ${UPLOAD_CONFIG.MAX_FILE_SIZE / (1024 * 1024)}MB`,
  UPLOAD_FAILED: 'Upload failed, please try again',
  NETWORK_ERROR: 'Network connection failed, please check your network and try again',
  SERVER_ERROR: 'Server error, please try again later'
};

// Success Messages
export const SUCCESS_MESSAGES = {
  UPLOAD_SUCCESS: 'personalCenter.myProfile.uploadSuccess'
};

export const DICT_NAMES = {
  MODEL: 'model',
  ASPECT_RATIO_PREFIX: 'imageAspectRatio_',
  RESOLUTION_PREFIX: 'Resolution_'
};
